import styled, { css } from 'styled-components';

export const HelperText = styled.p`
  font-size: 12px;
  line-height: 1.5;
  margin: 0 0 16px 0;

  ${({ theme }) => css`
    color: ${theme.colors?.onSurfaceVariant || '#888'};
  `}
`;

export const ErrorText = styled.p`
  font-size: 13px;
  line-height: 1.5;
  margin: 0 0 16px 0;

  ${({ theme }) => css`
    color: ${theme.colors?.error || '#EF5350'};
  `}
`;

export const CredentialField = styled.div`
  display: flex;
  align-items: stretch;
  gap: 8px;
  margin-bottom: 12px;
`;

export const CredentialValue = styled.code`
  flex: 1;
  font-size: 13px;
  word-break: break-all;
  display: flex;
  align-items: center;

  ${({ theme }) => css`
    padding: 10px ${theme.spacing?.level3 || '12px'};
    background-color: ${theme.colors?.surfaceContainerHigh || '#252540'};
    color: ${theme.colors?.onSurface || '#fff'};
    border-radius: ${theme.borderRadius?.medium || '8px'};
    font-family: ${theme.font?.fontFamilyMonospace || 'monospace'};
  `}
`;

export const ConfirmRow = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 13px;
  line-height: 1.5;
  cursor: pointer;
  margin-top: 20px;

  ${({ theme }) => css`
    color: ${theme.colors?.onSurface || '#fff'};
  `}
`;

export const ConfirmCheckbox = styled.input`
  margin: 2px 0 0 0;
  width: 16px;
  height: 16px;
  cursor: pointer;
  flex-shrink: 0;

  ${({ theme }) => css`
    accent-color: ${theme.colors?.primary || '#C1C1FF'};
  `}
`;
